import { useState } from "react";
import { submitUserFeedback } from "../../../../../../requests/feedback/requestCreators";
import flowioast from "../../../../../../utils/flowioast";

const useSubmitMessage = (message: string, files: File[]) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitMessage = () => {
    setIsSubmitting(true);
    return submitUserFeedback(message, files)
      .then(() => flowioast.success.fromIntlBase("feedback.submit.singular"))
      .catch((e) => flowioast.error.fromIntlBase("feedback.submit.singular", e))
      .finally(() => setIsSubmitting(false));
  };

  return [submitMessage, isSubmitting] as const;
};

export default useSubmitMessage;
